import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import optionalSubjectDetails from "../../../data/syllabus-data/optionalSubjectDetails";

export default function SubjectDetail() {
  const { subjectName } = useParams();
  const navigate = useNavigate();
  const decodedSubject = decodeURIComponent(subjectName);
  const data = optionalSubjectDetails[decodedSubject];

  const renderPoints = (points, level = 0) => {
    if (!points) return null;
    if (typeof points === "string") points = [points];
    if (!Array.isArray(points)) return null;

    return (
      <ul
        className={`ml-${level * 4} list-none space-y-1 text-gray-800`}
      >
        {points.map((point, index) => {
          if (typeof point === "string") return <li key={index}>{point}</li>;
          if (typeof point === "object")
            return (
              <li key={index}>
                <span className="font-semibold">{point.title}</span>
                {renderPoints(point.subpoints, level + 1)}
              </li>
            );
          return null;
        })}
      </ul>
    );
  };

  if (!data) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <h2 className="text-2xl font-semibold text-red-600 mb-4">
          No details found for {decodedSubject}
        </h2>
        <button
          onClick={() => navigate(-1)}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg"
        >
          Back to Subjects
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-6">
      <button
        onClick={() => navigate(-1)}
        className="bg-blue-600 text-white px-4 py-2 rounded-lg mb-6"
      >
        ← Back
      </button>

      <h2 className="text-3xl font-bold text-blue-900 mb-6">
        {decodedSubject}
      </h2>

      {data.papers.map((paper, i) => (
        <div key={i} className="mb-8 bg-white shadow-md rounded-xl p-6">
          <h3 className="text-xl font-semibold text-blue-800 mb-4">
            {paper.title}
          </h3>

          {paper.topics.map((topic, j) => (
            <div key={j} className="mb-4">
              <h4 className="text-blue-700 font-semibold mb-2">
                {topic.section}
              </h4>
              {renderPoints(topic.points)}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
